import { useContext, useEffect, useState } from "react";
import {
  Attribute,
  AttributeGroup,
  AttributeProperty,
  ComponentProps,
  ConfigContext,
  ConfigsProvider,
  PromiseLoader,
} from "react-builder";
import { useProductApi } from "../../custom-hooks/useProductApi";
import { Episode } from "../../types/multimedia-types";

@AttributeGroup({
  title: "SingleEpisodeProvider",
  blockName: "SingleEpisodeProvider",
  module: "multimedia",
  icon: "query",
})
export class SingleEpisodeProviderAttributes extends Attribute {
  @AttributeProperty({ type: "String" })
  episodeID = "";
}

export function SingleEpisodeProvider(props: ComponentProps<SingleEpisodeProviderAttributes>) {
  const content = useContext(ConfigContext);
  const singleEpisodeAPI = useProductApi<Episode>();
  const episodeID = props.attributes.episodeID
    ? content.getContent(props.attributes.episodeID)
    : "";
  const [episodePromise, setEpisodesPromise] = useState<Promise<Episode>>();

  useEffect(() => {
    const fetchEpisode = async () => {
      if (!singleEpisodeAPI) return;
      try {
        const episodePromise = singleEpisodeAPI.single(`multimedia/Episode/${episodeID}`, {
          populate: "subtitles subtitles.file",
        });
        setEpisodesPromise(episodePromise);
      } catch (error) {
        console.error("Error fetching Episodes:", error);
      }
    };

    fetchEpisode();
  }, [singleEpisodeAPI, episodeID]);

  return (
    <PromiseLoader<Episode> promise={episodePromise} loader={<></>}>
      {(episode) => (
        <ConfigsProvider configJson={{ episode }}>
          <>{props.children}</>
        </ConfigsProvider>
      )}
    </PromiseLoader>
  );
}

SingleEpisodeProvider.prototype.Props = SingleEpisodeProviderAttributes;

export default SingleEpisodeProvider;
